import { ToastContainer } from 'react-toastify';

import CloseIcon from '~/shared/assets/icons/cancel.svg';

import 'react-toastify/dist/ReactToastify.css';

export default function Toaster() {
  return (
    <ToastContainer
      className="custom-toast-container"
      toastClassName="custom-toast"
      bodyClassName="custom-body"
      position="bottom-left"
      autoClose={5000}
      hideProgressBar
      limit={5}
      stacked
      closeButton={({ closeToast }) => (
        <button className="custom-close-button" onClick={closeToast}>
          <CloseIcon className="custom-close-icon" />
        </button>
      )}
    />
  );
}
